import React, { FC } from "react";
import { logo } from "../../../../assets/images";
import { NavLink } from "react-router-dom";
import { RoutesE } from "../../../../routes/routesData";
import { useAppSelector } from "../../../../store/hooks";
import { selectCurrentUser } from "../../../../store/selectors/authSelectors";
import { UserRoleE } from "../../../../models/enums";

type LogoPropTypes = {
  className?: string;
};

const Logo: FC<LogoPropTypes> = ({ className = "" }) => {
  const user = useAppSelector(selectCurrentUser);

  return (
    <div className={className}>
      <NavLink
        to={
          user?.role === UserRoleE.Broadcaster
            ? RoutesE.DELIVERIES
            : RoutesE.HOME
        }
      >
        <img src={logo} alt="JUMBO Media" title="JUMBO Media" />
      </NavLink>
    </div>
  );
};

export default Logo;
